import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@core/auth/auth-guard.service';
import { GestaoAlertasComponent } from './pages/gestao-alertas.component';


const routes: Routes = [
  {
    path: '',
    component: GestaoAlertasComponent,
    canActivate: [AuthGuardService],
    data:{
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GestaoAlertasRoutingModule { }
